module.exports = __webpack_public_path__ + "static/media/covid19BackgroundBottom.c958490f.png";